var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStreamChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "72px",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "02744085-143D-42D6-A6B4-57E09E27AB1F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.91148,24.48 L59.28648,24.48 C60.3432,24.48 61.19796,23.63748 61.19796,22.59708 L61.19796,3.76584 C61.19796,1.68708 59.4864,2.0783375e-14 57.37296,2.0783375e-14 L53.21952,2.0783375e-14 C52.20564,2.0783375e-14 51.2346,0.39576 50.51652,1.10364 L31.71792,19.61052 C31.00188,20.31636 30.0288,20.71416 29.01492,20.71416 L20.18376,20.71416 C19.49016,20.71416 18.8088,20.52852 18.21516,20.17764 L11.53008,16.2282 C10.31832,15.51216 8.80464,15.51216 7.59288,16.2282 L0.9282,20.1654 C0.35088,20.50608 1.27897692e-14,21.11808 1.27897692e-14,21.77904 L1.27897692e-14,22.59708 C1.27897692e-14,23.63748 0.85476,24.48 1.91148,24.48",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.07224,0.857989997 C52.66668,-0.302770003 50.62872,-0.284410003 49.24356,0.904909997 L41.21004,7.81643 C40.5348,8.39783 39.67188,8.71811 38.7804,8.71811 L34.24344,8.71811 C33.14592,8.71811 32.10144,9.19955 31.39356,10.03799 L20.57952,22.79207 C19.67988,23.85287 18.2988,24.33839 16.96056,24.06095 L10.3122,22.68803 C9.81852,22.58603 9.30852,22.58603 8.8128,22.68803 L1.53816,24.19151 C0.64464,24.37511 0,25.18499 0,26.12747 L0,28.02263 C0,29.26703 1.10364,30.20135 2.28684,29.95859 L7.74792,28.83047 C8.89236,28.59383 10.08168,28.90187 10.96704,29.66483 L18.08256,35.78483 C19.70844,37.18223 22.14012,36.95987 23.48652,35.29319 L29.90232,27.34535 C30.35928,26.78231 30.96312,26.35799 31.64856,26.12135 L40.74492,22.99199 C41.6058,22.69619 42.33408,22.10867 42.80532,21.33143 L49.64748,10.03187 C50.75316,8.20607 53.0706,7.63079 54.85968,8.73851 L58.3032,10.87031 C59.5782,11.65979 61.2,10.71323 61.2,9.17915 L61.2,7.98575 C61.2,7.19831 60.84912,6.45371 60.2412,5.95187 L54.07224,0.857989997 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-Page-Builder-v1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.1-WebPageBuilder-EmptyWidgets",
    transform: "translate(-849.000000, -710.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pie",
    transform: "translate(707.000000, 540.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(30.000000, 170.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-Builder/Stream-Chart/40dp",
    transform: "translate(112.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Purple-Light",
    transform: "translate(5.401224, 34.793438)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey-Light",
    mask: "url(#mask-2)",
    fill: "#E5E5E5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.401224, -34.793438)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 115.2,
    height: 115.2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Purple",
    transform: "translate(5.400000, 14.400000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey-Light",
    mask: "url(#mask-4)",
    fill: "#E5E5E5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.400000, -14.400000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 115.2,
    height: 115.2
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamChart);
export default __webpack_public_path__ + "static/media/streamChart.a8b9d05052c66960dd0a4f07ddd64c7d.svg";
export { ForwardRef as ReactComponent };